import GraphQL from "../../api/graphql";
import isEmpty from "lodash/isEmpty";
import { make } from "vuex-pathify";

const ACCESS_LEVELS = {
    administrator: "ADMINISTRATOR",
    restrict: "RESTRICT",
    specific_restrict: "SPECIFIC_RESTRICTION",
    public: "PUBLIC"
};

const state = {
    accessLevel: null,
    currentPage: 1,
    term: "",
    documents: [],
    users: [],
    selectedItems: [],
    selectedUsers: [],
    pageCount: 0
};

const mutations = make.mutations(state);

const actions = {
    async fetch({ state, rootState }) {
        const currentPage = state.currentPage;
        const term = state.term;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query($currentPage: Int!, $term: String!) {
                    users {
                        id
                        name
                    }

                    documents(page: $currentPage, text: $term, per_page: 100) {
                        documents {
                            id: id
                            title_default
                            access_level
                        }
                        last_page
                    }
                }
            `,
            variables: {
                currentPage,
                term
            }
        });

        const documents = response.data.documents.documents.map(document => {
            let data = document;
            if (isEmpty(data.title_default)) {
                data.title_default = "Sem título";
            }

            return data;
        });

        this.set("manageDocuments/users", response.data.users);
        this.set("manageDocuments/documents", documents);
        this.set(
            "manageDocuments/pageCount",
            response.data.documents.last_page
        );
    },
    async fetchUsers({ rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query {
                    users {
                        id
                        name
                    }
                }
            `,
            variables: {}
        });

        this.set("manageDocuments/users", response.data.users);
    },
    async update({ state, rootState, dispatch }) {
        const ids = state.selectedItems.map(selected => selected.id);
        const users = state.selectedUsers;
        const accessLevel = ACCESS_LEVELS[state.accessLevel];

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($ids: [ID!]!, $accessLevel: AccessLevelEnum!, $users: [ID!]) {
                    updateDocumentAccessLevel(document_id: $ids, access_level: $accessLevel, users: $users)
                }
            `,
            variables: {
                ids,
                accessLevel,
                users
            }
        });

        await dispatch("fetch");
        this.set("manageDocuments/selectedItems", []);
    },
    reset() {
        this.set("manageDocuments/accessLevel", null);
        this.set("manageDocuments/currentPage", 1);
        this.set("manageDocuments/documents", []);
        this.set("manageDocuments/users", []);
        this.set("manageDocuments/selectedItems", []);
        this.set("manageDocuments/selectedUsers", []);
    }
};

export default { state, mutations, actions };
